import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import FinalGradeTable from "./routes/FinalGradeTable";
export default store => ({
  path: ":termId/templates",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [FinalGradeTable(store)],
});
